module.exports = __webpack_public_path__ + "static/media/bedExplore.00513181.png";